import React from 'react';

export const OceanLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <div className="w-8 h-8 flex items-center justify-center">
    <svg
      {...props}
      viewBox="0 0 150 150"
      xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full"
    >
      <defs>
        <style>
          {`.ocean-blue { fill: #3c55f5; fill-rule: evenodd; }`}
          {`.ocean-none { fill: none; }`}
        </style>
      </defs>
      <g>
        <path className="ocean-none" d="M0,0H150V150H0V0Z" />
      </g>
      <path
        className="ocean-blue"
        d="M61.3,18.69c0-2.44,1.96-4.42,4.41-4.52h17.23c2.46,.1,4.41,2.08,4.41,4.52s-2.06,4.53-4.6,4.53h-16.86c-2.53,0-4.6-2.02-4.6-4.53Z"
      />
      <path
        className="ocean-blue"
        d="M42.82,34.61c.09-2.92,2.66-5.18,5.6-5.18h52.06c3.03,0,5.47,2.48,5.38,5.51-.09,2.92-2.66,5.18-5.6,5.18h-12.86c-1.79,0-3.22,1.53-3.05,3.35,.15,1.59,1.58,2.76,3.18,2.76h39.66c2.75,0,5.3,1.47,6.66,3.85,1.21,2.11,2.31,4.3,3.3,6.55,1.32,3.02-.93,6.39-4.23,6.39h-18.6c-2.24,0-4.04,1.92-3.82,4.19,.19,1.99,1.98,3.44,3.98,3.44h21.59c3.75,0,6.58,3.31,6.07,7-.55,4.01-1.46,7.91-2.68,11.66-.83,2.52-3.18,4.23-5.84,4.23h-54.67c-2.58,0-4.67,2.13-4.6,4.73,.07,2.5,2.28,4.44,4.79,4.44h48.61c2.47,0,3.95,2.78,2.52,4.78-12.39,17.42-32.82,28.8-55.93,28.8s-43.55-11.38-55.93-28.8c-1.43-2,.05-4.78,2.52-4.78h11.14c2.59,0,4.67-2.13,4.6-4.72-.07-2.5-2.27-4.44-4.79-4.44H15.08c-2.67,0-5.02-1.71-5.85-4.23-1.23-3.76-2.13-7.65-2.69-11.66-.04-.23-.05-.46-.06-.69v-.33c.09-3.26,2.73-5.97,6.13-5.97h63.27c2.24,0,4.03-1.92,3.81-4.19-.19-1.99-1.98-3.44-3.98-3.44H15.76c-3.31,0-5.55-3.37-4.23-6.39,.98-2.25,2.08-4.43,3.3-6.55,1.37-2.38,3.91-3.85,6.66-3.85H61.27c1.8,0,3.23-1.54,3.05-3.35-.15-1.59-1.58-2.76-3.18-2.76h-12.95c-3.03,0-5.47-2.48-5.38-5.51Z"
      />
    </svg>
  </div>
);
